export default __webpack_public_path__ + "static/media/dashboard_right.4befd1f3.svg";